import Typography from '@alltrails/shared/denali/components/Typography';
import { FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import badgeCheckSrc from 'components/icons/badge-check.svg';
import classNames from 'classnames';
import { Key } from 'react';
import * as styles from './ProFeatureComparisonTable.module.scss';

type Feature = {
  text: JSX.Element;
  pro: boolean;
  new?: boolean;
};

type ProFeatureComparisonTableProps = {
  features: Feature[];
  containerStyles?: string;
};

function Badge() {
  const intl = useIntl();
  return <img alt={intl.formatMessage({ defaultMessage: 'badge' })} src={badgeCheckSrc} />;
}

// https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=1591%3A72835
const ProFeatureComparisonTable = ({ features, containerStyles }: ProFeatureComparisonTableProps) => (
  <table className={classNames(styles.features, containerStyles)}>
    <thead>
      <tr>
        <th className={styles.head}>
          <FormattedMessage defaultMessage="Features" />
        </th>
        <th>
          <FormattedMessage defaultMessage="Free" />
        </th>
        <th>
          <FormattedMessage defaultMessage="AllTrails+" />
        </th>
      </tr>
    </thead>
    <tbody>
      {features.map((feature, index) => (
        <tr key={index as Key} className={styles.feature}>
          <td>
            <Typography variant="text200">{feature.text}</Typography>
          </td>
          <td>
            {!feature.pro && <Badge />}
            {feature.new && (
              <div className={styles.newBadge}>
                <FormattedMessage defaultMessage="New" />
              </div>
            )}
          </td>
          <td>
            <Badge />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ProFeatureComparisonTable;
